import axios from '../api/axios';

export interface KomootPreviewMetadata {
  url: string;
  title: string | null;
  description: string | null;
  imageUrl: string | null;
  siteName: string | null;
  distanceKm: number | null;
}

const metadataCache = new Map<string, KomootPreviewMetadata | null>();
const metadataRequestCache = new Map<string, Promise<KomootPreviewMetadata | null>>();

export const loadKomootMetadata = async (url: string) => {
  if (metadataCache.has(url)) {
    return metadataCache.get(url) || null;
  }

  const pendingRequest = metadataRequestCache.get(url);

  if (pendingRequest) {
    return pendingRequest;
  }

  const request = axios
    .get<KomootPreviewMetadata>('/link-previews/komoot', {
      params: { url },
    })
    .then((response) => {
      metadataCache.set(url, response.data);
      return response.data;
    })
    .catch(() => {
      metadataCache.set(url, null);
      return null;
    })
    .finally(() => {
      metadataRequestCache.delete(url);
    });

  metadataRequestCache.set(url, request);

  return request;
};